export const SET_SUPPORTED = 'SET_SUPPORTED'
